import { set, unset, contains, isOver } from "../../js/lib/util";

const breakpoint = 767;

const getBottom = (button) => {
  return `${button.offsetHeight + 20}px`;
};

const getLeft = (button, tooltip) => {
  return `-${tooltip.offsetWidth / 2 - button.offsetWidth / 2}px`;
};

export default (el: HTMLElement) => {
  const tooltipButtons = Array.from(el.querySelectorAll(".js-tooltip-button"));

  for (let button of tooltipButtons) {
    const parentBtn = button.parentNode;
    if (!parentBtn) {
      continue;
    }

    const tooltip = parentBtn.querySelector(".js-tooltip");

    if (isOver(breakpoint) && tooltip) {
      tooltip.style.bottom = getBottom(button);
      tooltip.style.left = getLeft(button, tooltip);
    }

    button.addEventListener("click", (e) => {
      if (contains(parentBtn, "active")) {
        unset(parentBtn, "active");
      } else {
        set(parentBtn, "active");
      }
    });
  }

  document.body.addEventListener("click", (e) => {
    if (e.target.closest(".js-tooltip-button")) {
      return;
    }
    for (let button of tooltipButtons) {
      const parentBtn = button.parentNode;
      unset(parentBtn, "active");
    }
  });

  window.addEventListener("resize", () => {
    for (let button of tooltipButtons) {
      unset(button, "active");

      const tooltip = button.querySelector(".js-tooltip");

      if (tooltip) {
        if (!isOver(breakpoint)) {
          tooltip.style.bottom = 0;
          tooltip.style.left = 0;
        } else {
          if (window.innerWidth > 1024) {
            tooltip.style.bottom = getBottom(button);
            tooltip.style.left = getLeft(button, tooltip);
          } else {
            tooltip.style.bottom = "inherit";
            tooltip.style.left = 0;
          }
        }
      }
    }
  });
};
